// extracted by mini-css-extract-plugin
export var container = "MaxDeposit-module--container--15707";
export var label = "MaxDeposit-module--label--b1cbc";
export var supportLink = "MaxDeposit-module--supportLink--7c57c";